
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

const products = {
  "apis-cera-collection-6": {
    id: "apis-cera-collection-6",
    name: "Apis Cera Collection 6",
    description: "Свечи из коллекции Classic 6 для ваших роскошных сервировок. Интерьерные свечи из 100 % пчелиного воска это не просто источник тепла и уюта, но и предмет, который украсит любой интерьер. Восхитительная текстура и натуральный природный оттенок делает эти свечи неотъемлемым элементом декора. Они настолько красивы, что будут радовать глаз даже в те моменты, когда свеча не горит.\n\nКаждое зажигание свечей из коллекции Classic 6 превратит обычный ужин в волшебное событие. Их тонкий изысканный медовый аромат с цветочными нотами наполняет пространство и создает атмосферу спокойствия и гармонии. А великолепный дизайн упаковки превращает свечи из коллекции Classic 6 в идеальный подарок, который подчеркнет ваш утонченный вкус и любовь к прекрасному.\nС интерьерными свечами Budnik Bee Garden каждый момент становится особенным. Пусь их совершенная форма и завораживающий аромат принесут в ваш дом неповторимую атмосферу уюта и роскоши.",
    price: "790 ₽",
    images: [
      "/lovable-uploads/db685550-4be4-4349-8bab-debadd622185.png",
      "/lovable-uploads/21d52996-1bcf-4a25-a3e2-643130441f00.png",
      "/lovable-uploads/0d739dc7-9400-414c-b7d1-48e5a6467219.png",
      "/lovable-uploads/eec753a8-56e2-43e1-b3b3-50c8706e007d.png"
    ],
    marketplaces: [
      {
        name: "OZON",
        url: "https://www.ozon.ru/product/nabor-svechey-pchelinyy-vosk-26-sm-h-2-sm-6-sht-1926749668/"
      },
      {
        name: "Яндекс Маркет",
        url: "https://market.yandex.ru/pr/51335668667"
      }
    ]
  }
};

const ProductDetail = () => {
  const { productId } = useParams();
  const product = productId ? products[productId as keyof typeof products] : null;

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Товар не найден</h1>
          <Link to="/" className="text-honey-600 hover:text-honey-700">
            Вернуться на главную
          </Link>
        </div>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-white pt-24">
      <div className="container mx-auto px-4 py-12">
        <nav className="text-sm text-gray-500 mb-8">
          <Link to="/" className="hover:underline">Главная</Link> {' > '} <Link to="/#products" className="hover:underline">Продукция</Link> {' > '} <span className="font-semibold">{product.name}</span>
        </nav>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-6">
            {product.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`${product.name} изображение ${index + 1}`}
                className="w-full rounded-xl shadow-md"
              />
            ))}
          </div>

          <div>
            <h1 className="font-cormorant-garamond text-4xl font-bold mb-4">{product.name}</h1>
            <p className="text-2xl font-semibold text-honey-700 mb-6">{product.price}</p>

            <div className="prose max-w-none mb-8 text-gray-700">
              {product.description.split('\n\n').map((paragraph, index) => (
                <p key={index} className="mb-4">{paragraph}</p>
              ))}
            </div>

            <div className="border-t border-gray-200 pt-6">
              <h3 className="font-semibold mb-4">Купить на маркетплейсах:</h3>
              <div className="flex space-x-4">
                {product.marketplaces.map((marketplace, i) => (
                  <a
                    key={i}
                    href={marketplace.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-black py-3 px-5 rounded-full text-sm font-medium transition-all"
                  >
                    {marketplace.name === "OZON" ? (
                      <>
                        <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full">
                          <ShoppingCart size={16} />
                        </div>
                        <span>Купить на OZON</span>
                      </>
                    ) : (
                      <>
                        <div className="w-8 h-8 flex items-center justify-center bg-red-500 text-white rounded-full">
                          <span className="text-xs font-bold">Я</span>
                        </div>
                        <span>Купить на Яндекс Маркете</span>
                      </>
                    )}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductDetail;
